//
// Generated class PaymentFeeTemplateLine
//

/// <reference path="PaymentFeeTemplateLine_ManagedObject.ts" />

class PaymentFeeTemplateLine extends PaymentFeeTemplateLine_ManagedObject
{

}
